<footer class="app-footer">
    <div class="app-footer__top">
        <div class="app-footer__brand">
            <span class="app-footer__logo">{{ appName }}</span>
            <span class="app-footer__divider">|</span>
            <img src="libs/Shared/assets/images/svg/Logo-white.svg" alt="Swipesum Logo" class="app-footer__partner">
        </div>
        <div class="app-footer__links">
            <div class="app-footer__link-group">
                <span class="app-footer__link-label">Call our support team</span>
                <a href="tel:18448775753" class="app-footer__link">1-844-877-5753</a>
            </div>
            <div class="app-footer__link-group">
                <span class="app-footer__link-label">Send us a message</span>
                <a href="mailto:support@swipesum.com" class="app-footer__link">support@swipesum.com</a>
            </div>
            <!-- TODO ADD THIS BACK WHEN WE HAVE A SUPPORT CENTER -->
            <!-- <div class="app-footer__link-group">
                <span class="app-footer__link-label">Browse our how-to index</span>
                <a href="#" class="app-footer__link">launch support center TODO</a>
            </div> -->
        </div>
    </div>
    <div class="app-footer__bottom">
        <div class="app-footer__legal">
            <a href="https://www.swipesum.com/legal/privacy-policy" class="app-footer__legal-link">Privacy Policy</a>
            <a href="https://www.swipesum.com/legal/terms-of-use" class="app-footer__legal-link">Terms of Use</a>
            <a href="https://www.swipesum.com/legal/platform-terms-of-service" class="app-footer__legal-link">Platform TOS</a>
        </div>
        <span class="app-footer__copyright">© 2018-{{ getYearForCopyright() }} Swipesum</span>
    </div>
</footer>